import { view } from '@yola/ws-sdk';
import helpers from 'src/js/modules/focal-point/helpers/index';
import getViewLeftOffset from 'src/js/modules/view/helpers/get-view-left-offset';

const getImageBounds = (imageNode, imageComputedStyles) => {
  const imageBoundsInIframe = view.accessors.getElementBoundsInIframe(imageNode);
  const leftOffset = getViewLeftOffset();
  const adjustedBounds = {
    ...imageBoundsInIframe,
    left: imageBoundsInIframe.left + leftOffset,
    x: imageBoundsInIframe.x + leftOffset,
    right: imageBoundsInIframe.right + leftOffset,
  };
  return helpers.calculateBoundsWithoutBorder(adjustedBounds, imageComputedStyles);
};

export default getImageBounds;
